export const CURRENT_USER = {
  id: "user-1",
  name: "Happy Ndikumana",
  email: "happyndikumana@example.com",
  avatar: "",
  // avatar: "https://i.pravatar.cc/100?img=1",
  emailVerified: true,
  onboardingCompleted: false,
  role: 'admin',
  maxRange: 99999,
  settings: {
    // Privacy settings
    defaultVisibility: "public",
    locationPrecision: "precise",
    analyticsConsent: true,
    // Location settings
    units: "miles",
    showMyLocationOnMap: true,
    showRadiusCircle: true,
    // Notification preferences (matching actual notification types)
    notifications: {
      likes: true,
      comments: true,
      system: true,
    },
    // Theme settings
    theme: "auto",
  },
};

export const MOCK_USERS = [
  { id: "user-2", name: "John Doe", avatar: "https://i.pravatar.cc/100?img=2" },
  {
    id: "user-3",
    name: "Jane Smith",
    avatar: "https://i.pravatar.cc/100?img=5",
  },
  {
    id: "user-4",
    name: "Jerry Lee",
    avatar: "https://i.pravatar.cc/100?img=7",
  },
  {
    id: "user-5",
    name: "Sam Park",
    avatar: "https://i.pravatar.cc/100?img=10",
  },
  {
    id: "user-6",
    name: "Maria Lopez",
    avatar: "https://i.pravatar.cc/100?img=6",
  },
  {
    id: "user-7",
    name: "Alex Chen",
    avatar: "https://i.pravatar.cc/100?img=8",
  },
  {
    id: "user-8",
    name: "Emma Wilson",
    avatar: "https://i.pravatar.cc/100?img=9",
  },
  {
    id: "user-9",
    name: "Chris Brown",
    avatar: "https://i.pravatar.cc/100?img=11",
  },
];
